const rawVersion = import.meta.env.VITE_APP_VERSION;

export const appVersion = typeof rawVersion === 'string' && rawVersion.length > 0
  ? rawVersion
  : '0.0.0';
